// import { useState, useEffect } from "react";
// import { Link } from "react-router-dom";
// import { LinearProgress, Typography } from "@mui/material";
// import { TransferWithinAStation } from "@mui/icons-material";

// import { IPDCFinalTable } from "../../../../components";
// import WideChartContainer from "../../../../components/Charts/WideChartContainer";

// import {ExecuteApiRequest, GetDataFromApiWithParams} from "../../../../services/api/ExecuteApiRequests";

// const InvestorActivityReportCard = () => {
//   const [activitiesSummary, setActivitiesSummary] = useState([]);
//   const [isLoading, setIsLoading] = useState(true);

//   useEffect(() => {
//     const fetchActivitiesSummary = async () => {
//       setIsLoading(true);
//       try {
//         const response = await GetDataFromApiWithParams("dashboard/executives/activitiesSummary");
        
//         setActivitiesSummary(response || []);
//         setIsLoading(false);
//       } catch (error) {
//         console.error("Error fetching activities summary:", error);
//       } finally {
//         setIsLoading(false);
//       }
//     };

//     fetchActivitiesSummary();
//   }, []);

//   return (
//     <Link to="/execActivities">
//       {
//         <WideChartContainer
//           THECHART={
//             isLoading ? (
//               <LinearProgress />
//             ) : (
//               <>
//                 {activitiesSummary && activitiesSummary.length > 0 ?(
//                   <IPDCFinalTable
//                     data={activitiesSummary}
//                     setData={setActivitiesSummary}
//                     showHeader={false}
//                     isSearchable={false}
//                   />
//                 ):<Typography>There is no activity data yet.</Typography>}
//               </>
//             )
//           }
//           title="Investor Activity Report"
//           link="/execActivities"
//           showMoreButton={false}
//           avatar={<TransferWithinAStation />}
//         />
//       }
//     </Link>
//   );
// };

// export default InvestorActivityReportCard;
// //import { DashboardProvider } from "../../../services/contexts/DashboardProvider";
// //import { useDashboardData } from "../../../services/hooks/useDashboardData";

// /*const SummaryReport = ({ data }) => {
//   return (
//     <Grid container spacing={2}>
//       <Grid item xs={6} sm={6} md={6}>
//         <Typography variant="subtitle1" component="div">
//           Export Summary
//         </Typography>
//       </Grid>
//       <Grid item xs={6} sm={6} md={6}>
//         <Typography variant="body1">{data.exportSummary}</Typography>
//       </Grid>
//       <Grid item xs={6} sm={6} md={6}>
//         <Typography variant="subtitle1" component="div">
//           Import Summary
//         </Typography>
//       </Grid>
//       <Grid item xs={6} sm={6} md={6}>
//         <Typography variant="body1">{data.importSummary}</Typography>
//       </Grid>
//       <Grid item xs={6} sm={6} md={6}>
//         <Typography variant="subtitle1" component="div">
//           Employment Summary
//         </Typography>
//       </Grid>
//       <Grid item xs={6} sm={6} md={6}>
//         <Typography variant="body1">{data.employmentSummary}</Typography>
//       </Grid>
//       <Grid item xs={6} sm={6} md={6}>
//         <Typography variant="subtitle1" component="div">
//           Import Substitution
//         </Typography>
//       </Grid>
//       <Grid item xs={6} sm={6} md={6}>
//         <Typography variant="body1">{data.importSubstitution}</Typography>
//       </Grid>
//       <Grid item xs={6} sm={6} md={6}>
//         <Typography variant="subtitle1" component="div">
//           Linkage
//         </Typography>
//       </Grid>
//       <Grid item xs={6} sm={6} md={6}>
//         <Typography variant="body1">{data.linkage}</Typography>
//       </Grid>
//     </Grid>
//   );
// };*/
//****************************************************************** */
import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { LinearProgress, Typography, Box, Grid, Paper } from "@mui/material";
import { TransferWithinAStation, TrendingUp, TrendingDown, People, Business } from "@mui/icons-material";

import WideChartContainer from "../../../../components/Charts/WideChartContainer";
import { GetDataFromApiWithParams } from "../../../../services/api/ExecuteApiRequests";

const InvestorActivityReportCard = () => {
  const [activitiesSummary, setActivitiesSummary] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [summaryMetrics, setSummaryMetrics] = useState(null);

  useEffect(() => {
    const fetchActivitiesSummary = async () => {
      setIsLoading(true);
      try {
        const response = await GetDataFromApiWithParams("dashboard/executives/activitiesSummary");
        
        // Log the response to see its structure
        console.log("API Response:", response);
        
        // Handle different response structures
        let data = [];
        if (Array.isArray(response)) {
          data = response;
        } else if (response?.data && Array.isArray(response.data)) {
          data = response.data;
        } else if (response?.activitiesSummary && Array.isArray(response.activitiesSummary)) {
          data = response.activitiesSummary;
        }
        
        setActivitiesSummary(data);
        
        // Calculate summary metrics from the data
        if (data && data.length > 0) {
          calculateSummaryMetrics(data);
        }
        
      } catch (error) {
        console.error("Error fetching activities summary:", error);
      } finally {
        setIsLoading(false);
      }
    };

    fetchActivitiesSummary();
  }, []);

  const calculateSummaryMetrics = (data) => {
    // Calculate summary metrics based on your data structure
    // This is an example - adjust according to your actual data fields
    const metrics = {
      totalActivities: data.length,
      totalExports: data.reduce((sum, item) => sum + (item.exportValue || 0), 0),
      totalImports: data.reduce((sum, item) => sum + (item.importValue || 0), 0),
      totalEmployment: data.reduce((sum, item) => sum + (item.employmentCount || 0), 0),
      activeProjects: data.filter(item => item.status === "active").length,
      totalValue: data.reduce((sum, item) => sum + (item.projectValue || 0), 0),
    };
    setSummaryMetrics(metrics);
  };

  const SummaryCard = ({ icon: Icon, label, value, color = "primary" }) => (
    <Paper
      elevation={0}
      sx={{
        p: 1,
        display: 'flex',
        alignItems: 'center',
        gap: 1,
        bgcolor: 'background.default',
        borderRadius: 2,
        height: '100%',
      }}
    >
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          width: 36,
          height: 36,
          borderRadius: '50%',
          bgcolor: `${color}.lighter`,
          color: `${color}.main`,
        }}
      >
        <Icon sx={{ fontSize: 18 }} />
      </Box>
      <Box sx={{ flex: 1, minWidth: 0 }}>
        <Typography variant="caption" color="text.secondary" noWrap>
          {label}
        </Typography>
        <Typography variant="body2" fontWeight="bold" noWrap>
          {typeof value === 'number' ? value.toLocaleString() : value}
        </Typography>
      </Box>
    </Paper>
  );

  return (
    <Link to="/execActivities" style={{ textDecoration: 'none', color: 'inherit' }}>
      <WideChartContainer
        THECHART={
          isLoading ? (
            <LinearProgress />
          ) : (
            <>
              {activitiesSummary && activitiesSummary.length > 0 && summaryMetrics ? (
                <Box sx={{ p: 1 }}>
                  {/* Four metrics in one row with thin green boundary */}
                  <Box sx={{ 
                    border: '1px solid #4caf50',
                    borderRadius: 2,
                    p: 1,
                    mb: 1.5,
                  }}>
                    <Grid container spacing={0.5}>
                      <Grid item xs={3}>
                        <SummaryCard
                          icon={TrendingUp}
                          label="Exports"
                          value={`$${summaryMetrics.totalExports.toLocaleString()}`}
                          color="success"
                        />
                      </Grid>
                      <Grid item xs={3}>
                        <SummaryCard
                          icon={TrendingDown}
                          label="Imports"
                          value={`$${summaryMetrics.totalImports.toLocaleString()}`}
                          color="info"
                        />
                      </Grid>
                      <Grid item xs={3}>
                        <SummaryCard
                          icon={People}
                          label="Employment"
                          value={summaryMetrics.totalEmployment.toLocaleString()}
                          color="warning"
                        />
                      </Grid>
                      <Grid item xs={3}>
                        <SummaryCard
                          icon={Business}
                          label="Active"
                          value={summaryMetrics.activeProjects}
                          color="primary"
                        />
                      </Grid>
                    </Grid>
                  </Box>
                  
                  {/* Total Value Summary */}
                  <Box sx={{ p: 1.5, bgcolor: 'primary.lighter', borderRadius: 2 }}>
                    <Typography variant="caption" color="primary.dark">
                      Total Portfolio Value
                    </Typography>
                    <Typography variant="h6" color="primary.dark" fontWeight="bold">
                      ${summaryMetrics.totalValue.toLocaleString()}
                    </Typography>
                  </Box>
                </Box>
              ) : (
                <Box sx={{ 
                  display: 'flex', 
                  alignItems: 'center', 
                  justifyContent: 'center',
                  height: 200 
                }}>
                  <Typography color="text.secondary">
                    There is no activity data yet.
                  </Typography>
                </Box>
              )}
            </>
          )
        }
        title="Investor Activity Report"
        link="/execActivities"
        showMoreButton={false}
        avatar={<TransferWithinAStation />}
      />
    </Link>
  );
};

export default InvestorActivityReportCard;
